// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__URPRu","footer":"ChangeClinic_footer__2jgKv"};